import { computed } from 'vue'
export * from './use-utils'
const isMobile = computed(() => {
  const userAgent =
    navigator.userAgent || navigator.vendor || (window as any).opera
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
    userAgent
  )
})

export { isMobile }
